import { useState } from "react";
import { PageHeader } from "@/components/common/PageHeader";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { FileBarChart } from "lucide-react";
import {
  ConsolidatedStatement,
  SalesLedgerReport,
  ItemWiseReport,
  ParentCompanyReport,
  DateWiseReport,
} from "@/components/sales-reports/EnhancedReports";

export default function SalesReports() {
  const [tab, setTab] = useState("consolidated");
  return (
    <div className="space-y-6">
      <PageHeader title="Sales Reports" subtitle="Invoice-date based · from confirmed sales bills (incl. Tally imports)" />
      <Tabs value={tab} onValueChange={setTab} className="space-y-3">
        <TabsList data-testid="salesreports-tabs" className="flex-wrap bg-stone-100">
          <TabsTrigger value="consolidated" data-testid="sr-tab-consolidated">Consolidated</TabsTrigger>
          <TabsTrigger value="register" data-testid="sr-tab-register">Sales Register</TabsTrigger>
          <TabsTrigger value="itemwise" data-testid="sr-tab-itemwise">Item-Wise</TabsTrigger>
          <TabsTrigger value="buyerwise" data-testid="sr-tab-buyerwise">Buyer-Wise</TabsTrigger>
          <TabsTrigger value="datewise" data-testid="sr-tab-datewise">Date-Wise</TabsTrigger>
        </TabsList>
        <TabsContent value="consolidated"><ConsolidatedStatement /></TabsContent>
        <TabsContent value="register"><SalesLedgerReport /></TabsContent>
        <TabsContent value="itemwise"><ItemWiseReport /></TabsContent>
        <TabsContent value="buyerwise"><ParentCompanyReport /></TabsContent>
        <TabsContent value="datewise"><DateWiseReport /></TabsContent>
      </Tabs>
      <p className="flex items-center gap-1.5 text-xs text-muted-foreground">
        <FileBarChart className="h-3.5 w-3.5" />
        Reports exclude cancelled invoices and draw only on confirmed sales bills. Use filters &amp; drill-downs instead of separate reports.
      </p>
    </div>
  );
}
